import { defineMessages } from 'react-intl';

export default defineMessages({
  AcomConnectError: {
    defaultMessage: "Couldn't connect to Access Commander. Please try again.",
    id: 'acom.connect.error',
  },
  AcomConnectTimeout: {
    defaultMessage: 'Connecting to Access Commander is taking longer than expected. Please try again.',
    id: 'acom.connect.timeout',
  },
  LoadingUsersSurveysError: {
    defaultMessage: 'Survey couldn’t be loaded. Please try again later.',
    id: 'LoadingUsersSurveysError',
  },
  SharedNotificationCopyingNotAllowed: {
    defaultMessage: "Your browser doesn't allow copying to the clipboard",
    id: 'shared.notification.copyingNotAllowed',
  },
  SurveyAnswerError: {
    defaultMessage: 'Survey Answer Error',
    id: 'SurveyAnswerError',
  },
  SurveySuccessfullyAnswered: {
    defaultMessage: 'Survey successfully answered',
    id: 'SurveySuccessfullyAnswered',
  },
});
